import React, { useState } from 'react';
import { Maximize2 } from 'lucide-react';
import { KeyboardKeyButton } from 'components';

interface Props {
  resizeWindow: any;
}

const VMFullscreenButton = (props: Props) => {
  const [active, setActive] = useState(false);

  const resize = () => {
    props.resizeWindow();
  };

  /**
   * Handles fullscreen events when fullscreen-button is clicked
   * and also when user exit fullscreen mode by pressing escape
   */
  const goFullscreen = () => {
    const doc = window.document as any;
    const docEl = doc.documentElement as any;

    const fullscreenChangeEvents = [
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'fullscreenchange',
      'MSFullscreenChange',
    ];

    const requestFullScreen =
      docEl.requestFullscreen ||
      docEl.mozRequestFullScreen ||
      docEl.webkitRequestFullScreen ||
      docEl.msRequestFullscreen;
    const cancelFullScreen =
      doc.exitFullscreen ||
      doc.mozCancelFullScreen ||
      doc.webkitExitFullscreen ||
      doc.msExitFullscreen;

    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      requestFullScreen.call(docEl);
      setActive(true);
      resize();
    } else {
      cancelFullScreen.call(doc);
      setActive(false);
      resize();
    }

    const exitHandler = () => {
      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        fullscreenChangeEvents.forEach((event: string) => {
          doc.removeEventListener(event, exitHandler, false);
        });
        setActive(false);
        resize();
      }
    };

    if (doc.addEventListener) {
      fullscreenChangeEvents.forEach((event: string) => {
        doc.addEventListener(event, exitHandler, false);
      });
    }
  };

  return (
    <KeyboardKeyButton
      type="button"
      title="Fullscreen"
      aria-label="Fullscreen"
      {...props}
      isSelected={active}
      onClick={() => goFullscreen()}
    >
      <Maximize2 size={20} aria-hidden={true} />
    </KeyboardKeyButton>
  );
};

export { VMFullscreenButton };
